import './components/lesson_item';
import './components/lessons_filter_form';
import './components/questions_cta';
import './index.scss';
import 'components/handle_title_segment';
import 'styles/components/_alerts.scss';
import 'styles/components/_carousel.scss';
import 'styles/components/_pagination.scss';
import applyCountdown from 'utils/countdown';
import { MediaQuery } from 'utils/media_query';

(function ($) {
  const $page = $('.js-lessons-page');

  if (MediaQuery.is('lt_md')) {
    vendorManager.ensure('swiper', () => {
      const swipers = $page.find('.swiper-container');

      swipers.toArray().forEach(el => {
        let currentSwiper = new Swiper(el, {
          grabCursor: true,
          paginationClickable: true,
          slidesPerView: 2,
          spaceBetween: 30,
          breakpoints: {
            480: {
              slidesPerView: 1,
              spaceBetween: 0
            }
          },
          pagination: el.querySelector('.swiper-pagination')
        });
        currentSwiper.update();
      });
    });
  }

  if (gon.flags.freemium_lessons) {
    applyCountdown({
      selector: '.q-lesson-freemium-banner .limit-countdown',
      template: '%H:%M:%S'
    });
  }
})(jQuery);
